import { PageInfo } from 'types'

export const pageList: Array<PageInfo> = [
  { title: '타이머', url: '/timer' },
  { title: '통계', url: '/stats' },
  { title: '플래너', url: '/planner' },
  { title: '수험정보', url: '/examinfo' },
]
